<tt-page>
    <tt-production-routing-comp class="col-xs-12 col-md-3 sp-0" [params]="params" (submit)="onSubmit()"></tt-production-routing-comp>
</tt-page>
